<div class="modal-header">
  <h4 class="col-11 modal-title">
    <img alt="Brand" src="{{directoryImages}}/assets/images/dhl-official2.png">
  </h4>
  <button type="button" class="close" data-dismiss="modal" aria-hidden="true" (click)="modalRef.hide()">×</button>
</div>
<div class="modal-body">
  <p [innerHtml]="message"></p>
  <!--<div class="panel panel-default">
    <div class="panel-heading" role="tab" id="headingOne">
      <h4 class="panel-title">
        <a class="collapsed" data-toggle="collapse" href="#panelDetallesError" aria-expanded="false" aria-controls="panelDetallesError">
          {{'Shared.reintento-dia-entrega' | translate}}
        </a>
      </h4>
    </div>
    <div id="panelDetallesError" class="panel-collapse collapse" role="tabpanel" aria-labelledby="headingOne">
      <div class="panel-body" id="detallesError">
      </div>
    </div>
  </div>-->
</div>
<div class="modal-footer  btnSentStatus">
  <button type="button" class="btn btn-default" data-dismiss="modal"  (click)="modalRef.hide()" style="margin-left: auto;">{{'Shared.TxtModalClose' | translate}}</button>
</div>
